import AddContact from './AddContact';

export default AddContact;
